import { useState, useEffect } from 'react'
import { useParams } from "react-router";
import { useCarts, useCartsDispatch } from '../contexts/CartContext';
import { useNavigate } from "react-router";
import axios from 'axios';


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function Products() {
  const carts = useCarts();
  // const userCon = useUserContext();
  const [data, setData] = useState([])

  // const auth = useAuth();
  const navigate = useNavigate();

  const apiurl = `${process.env.REACT_APP_API}/products.php`
  const imgurl = `${process.env.REACT_APP_URL}/image/products`


  // const cartQty = useCartsQty();
  const dispatch = useCartsDispatch();

  const fetchProducts = async () => {
      try {
        const result = await axios.get(`${apiurl}?mode=getactive`);
        
        // console.log(result);
        // console.log(result.data);
        // if(result.data.length>0) {
        if(result.data && result.data[0].length>0) {  
          // const data = await response.json();
          // console.log(result.data[0]);
          setData(result.data[0]);
          return result.data[0];
        }

      }
      catch(err) {
          console.log(err);
        }
  }



  useEffect(() => {

    fetchProducts();

  },[])



  let { id } = useParams();
  // let prods = products;
  let prods = data;

  if(typeof(id) != "undefined") {
     prods = data?.filter( i => i.category===id)
  } 
  // console.log(currentUser);
  // console.log(cu['email']);

  // console.log(id)
  const setCart = async (pd) => {
    // console.log(pd)

    const cartitem = carts.filter((cart) => cart.pdid === pd.id);
    if (cartitem && cartitem.length > 0) {
      dispatch({
        type: 'changed',
        // id: pd.id,
        pdid: pd.id,
        name: pd.name,
        // discount: 0,
        price: pd.price,
        quantity: 1,
        imageSrc: pd.img,

      });
      
    } else {
      dispatch({
        type: 'added',
        id: pd.id,
        pdid: pd.id,
        name: pd.name,
        // discount: 0,
        price: pd.price,
        quantity: 1,
        imageSrc: pd.img,

      });
    };

    // const response = await axios.get(`/carts?productId=${product.id}`);
    // if (response.data && response.data.length > 0) {
    //   // update cart
    //   const orderItem = response.data[0];
    //   orderItem.qty = parseInt(orderItem.qty) + 1;
    //   orderItem.totalPrice =
    //     parseInt(orderItem.price) * parseInt(orderItem.qty);
    //   dispatch(updateCart(orderItem));
    // } else {
    //   // insert cart
    //   const orderItem = {
    //     qty: 1,
    //     price: product.price,
    //     name: product.name,
    //     totalPrice: product.price,
    //     note: "",
    //     productId: product.id,
    //   };
    //   dispatch(inputCart(orderItem));
    // }
  };

  // const handleLogout = () => {
  //   //
  //   dispatch({
  //       type: 'logout',
  //     });

      // navigate("/");    
  // }


  //   {  if (!cu) {
  //     navigate("/");
  //     return;
  //   }
  // }

  return (
    <div className="py-2 sm:py-1">
          <div className="mx-auto  px-1 md:px-2">
            <div className="overflow-y-auto h-[calc(100vh-50vh)] sm:h-[calc(100vh-160px)] mx-auto grid max-w-2xl grid-cols-2 gap-x-2 gap-y-6 border-t border-gray-200 p-4 sm:mt-4  md:mx-0 md:max-w-none sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6">
              {prods.map((prod) => (
                <div key={prod.id} className="flex max-w-xl flex-col ">
                    <div className="flex p-0 hover:border-orange-500 hover:border-2 hover:rounded-md hover:cursor-crosshair">
                      <img alt="" className="w-full aspect-square rounded-md bg-gray-50"
                          src={`${imgurl}/${prod.img}`}
                          // onClick={prod => handleClick(prod.id)}
                          onClick={() => setCart(prod)}
                      />
                    </div>
                  <div className="flex w-full rounded-lg items-center justify-between  text-xs pt-2">
                    <p
                      // href={prod.category}
                      className="relative z-10  px-3 py-1.5 font-medium"
                    >
                      {prod.name}
                    </p>
                    <p className="relative z-10 rounded-full bg-gray-300 px-3 py-1.5 font-medium text-gray-700 hover:bg-gray-100">
                        {prod.price}฿
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
  )
}

export default Products